import {
    Box,
    LinearProgress,
    createTheme,
    ThemeProvider,
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import get_token from "../lib/get_token";
import get_cid from '../lib/get_cid';
import { configState } from '../lib/State';

const progressTheme = createTheme({
    components: {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: '15px',
                    borderRadius: '10px',
                    border: '2px solid white',
                    background: '#e6e6e6',
                },
                bar: {
                    borderRadius: '10px',
                    background: 'linear-gradient(to right, #0672d5, #1acaf3)'
                }
            }
        }
    }
})

function HomeCalorie(props) {
    const { login } = props;
    const [calorie, setCalorie] = useState(0);
    const token = get_token();
    const cid = get_cid();

    const load_data = async () => {
        let result = await axios.post(configState.api + '/hr/get_kcal_loop', {
            token: token,
            mcd: login.mcd,
            level: login.level,
            cid: cid,
        });
        setCalorie(result.data.amount);
    }
    useEffect(() => {
        load_data();
    }, []);

    return (
        <Box
            sx={{
                // marginTop: '-130px',
                paddingTop: '15px',
                paddingBottom: '15px',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <ThemeProvider theme={progressTheme}>
                <LinearProgress
                    variant='determinate'
                    value={calorie / 10}
                    sx={{ width: '60%' }} />
            </ThemeProvider>
            <Box
                sx={{
                    display: 'flex',
                    marginLeft: '10px',
                    // color: 'white',
                    fontFamily: 'BebasNeue',
                    alignItems: 'flex-end',
                }}>
                <Box
                    sx={{
                        fontSize: '20px'
                    }}>
                    {calorie}
                </Box>
                <Box sx={{fontSize: '18px'}}>/</Box>
                <Box sx={{fontSize: '18px'}}>1000kcal</Box>
            </Box>
        </Box>
    )
}

export default HomeCalorie;